// ==========================================================================
// HLS 
// ==========================================================================

import Hls from 'hls.js';
import controls from '../controls';
import is from '../utils/is';
import { silencePromise } from '../utils/promise';
import { triggerEvent } from '../utils/events';
const hls = {

  ishls(url) {
    if (is.array(url)) {
      const [{src},] = url;
      url = src;
    }
    //if (/(^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#,?&*//=]*)(.m3u8)\b([-a-zA-Z0-9@:%_\+.~#,?&//=]*))/.test(url)) {
    if (/^https?:\/\/[a-zA-Z0-9.\/?=_%&:-]+(?:.m3u8|\(hls\))[a-zA-Z0-9.\/?=_%&:-]*/.test(url)) {
      return true;
    }
    return false;
  },

  setup(path) {
    const player = this;
    let url = path;
    let failover_url;
    if (is.array(path)) {
      const [fistElement, secondElement] = path;
      var {src} = fistElement;
      url = src;
      var { src } = secondElement ? secondElement : fistElement;
      failover_url = src;
      // console.log(url, failover_url);
    }
    
    //const url = src;
    return new Promise((resolve, reject) => {
      if (url === "") {
        reject();
      }
      // if (hls.ishls.call(this, url)) {
        if (Hls.isSupported()) {
          const defaultOptions = {};
          this.updateQuality = (newQuality) => {
            if (newQuality === 0) {
              this.hls.currentLevel = -1; // Enable AUTO quality if option.value = 0
            } else {
              this.hls.levels.forEach((level, levelIndex) => {
                if (level.height === newQuality) {
                  console.log(`Found quality match with ${newQuality}`);
                  this.hls.currentLevel = levelIndex;
                }
              });
            }
          };

          const config = {
            debug: false,
            // backBufferLength: 60 * 1.5,
            manifestLoadingTimeOut: 2000,
            // nudgeOffset: 1,
            // nudgeMaxRetry: 10,
            lowLatencyMode: false,
            // backBufferLength: 30,
            // liveSyncDuration: 6,
            // liveDurationInfinity: false,
          };
        
          if (this.hls) {
            this.hls.destroy();
            this.hls = null;
          }
          this.initAudioMenu = false;
          this.hls = new Hls(config);
          this.hls.attachMedia(this.media);
          this.hls.loadSource(url);
  
          //window.hls = this.hls;

          this.hls.on(Hls.Events.MANIFEST_PARSED, (event, data) => {
            // Transform available levels into an array of integers (height values).
            const availableQualities = this.hls.levels.map((l) => l.height);
            if (availableQualities[0] !== undefined) {
              availableQualities.unshift(0); //prepend 0 to quality array
              availableQualities.sort((a, b) => b - a);
    
              // Add new qualities to option
              defaultOptions.quality = {
                default: 720, //Default - AUTO
                options: availableQualities,
                forced: true,
                onChange: (e) => this.updateQuality(e),
              };
              
              this.hls.on(Hls.Events.LEVEL_SWITCHED, (event, data) => {
                this.hlsquality = this.hls.levels[data.level].height;
                if (this.hls.autoLevelEnabled) {
                  var settingmenu = document.querySelector(".plyr__menu__container [data-plyr='settings'][value='quality'] span span");
                  settingmenu.innerHTML = `Auto (${this.hls.levels[data.level].height}p)`;
                } 
                var qualitymenu = document.querySelector(".plyr__menu__container [data-plyr='quality'][value='0'] span");
                if (this.hls.autoLevelEnabled) {
                  qualitymenu.innerHTML = `Auto (${this.hls.levels[data.level].height}p)`;
                } else {
                  qualitymenu.innerHTML = "Auto";
                }
              });

            } else {
              defaultOptions.quality = {
                default: 0,
                // The options to display in the UI, if available for the source media
                options: [0],
                forced: false,
                onChange: null,
              };
            }
            resolve(defaultOptions.quality);
          });

          this.hls.on(Hls.Events.ERROR, (event, data) => {
            var errorType = data.type;
            var errorDetails = data.details;
            var errorFatal = data.fatal;
            if (errorType == Hls.ErrorTypes.NETWORK_ERROR) {
              // if (errorDetails == Hls.ErrorDetails.MANIFEST_LOAD_TIMEOUT || errorDetails == Hls.ErrorDetails.MANIFEST_LOAD_ERROR) {
              //   reject();
              // } else {
              //   this.hls.loadSource(failover_url);
              // }
              if (errorFatal) {
                this.hls.loadSource(failover_url);
              }
            }

            if (errorType == Hls.ErrorTypes.MEDIA_ERROR) {
              // if (errorDetails == Hls.ErrorDetails.MANIFEST_INCOMPATIBLE_CODECS_ERROR) {
              //   reject();
              // } else {
              //   this.hls.loadSource(failover_url);
              // } 
              if (errorFatal) {
                this.hls.loadSource(failover_url);
              }
            }
          });

          this.hls.on(Hls.Events.AUDIO_TRACKS_UPDATED, (event, data) => {
            this.debug.log("AUDIO_TRACKS_UPDATED", this.hls.audioTracks);
            hls.setAudioTrack.call(this);
          });

          this.hls.on(Hls.Events.AUDIO_TRACK_LOADED, (event, data) => {
            this.debug.log("Hls.Events.AUDIO_TRACK_LOADED", this.hls.audioTracks);
            if (!this.initAudioMenu) {
              this.initAudioMenu = true;
              controls.setAudiosMenu.call(this);
            }

            if (data.details.live) {
              if (player.duration > data.details.totalduration) {
                player.liveduration = data.details.totalduration;
              }
            }
          });

          this.hls.on(Hls.Events.AUDIO_TRACK_SWITCHED, (event, data) => {
            this.debug.log("AUDIO_TRACK_SWITCHED", data.id);
            this.storage.set({audioTrack: data.id});
          });

          this.hls.on(Hls.Events.MEDIA_ATTACHED, function () {
            //player.muted = true;
            //player.play();
            if (player.config.autoplay) {
              player.once('canplay', () => silencePromise(player.play()));
            }
          });

        } else {
          player.media.src = url;
          reject();
        }
      // } else {
      //   reject();
      // }
    });
  },

  getLabel(trackid) {
    if (!this.hls) {
      return null;
    }
    if(trackid === undefined) {
      trackid = this.hls.audioTrack;
      if (trackid == -1) {
        return null;
      } 
    }
    if (this.hls.audioTracks.length == 0) {
      return null;
    }
    return this.hls.audioTracks[trackid].name;
  
  },

  setAudioTrack(trackid) {
    if (!this.hls) {
      return;
    }
    if (this.hls.audioTracks.length == 0) {
      return;
    }
    if(is.number(trackid)) {
      this.hls.audioTrack = trackid;
    } else {
      trackid = this.hls.audioTrack;
      if (trackid == -1) {
        const audioTrack = this.storage.get('audioTrack');
        if (is.number(audioTrack)) {
          this.hls.audioTrack = audioTrack;
        }
      } 
    }
  },
};

export default hls;